import usersIcon from 'assets/images/icons/users-green.svg';
export const UsersTabsList = [
  {
    id: 1,
    title: 'tabs_users',
    value: 'users',
    breadcrumbValue: { icon: usersIcon, items: ['tabs_super_admin', 'tabs_users'] },
  },
  {
    id: 2,
    title: 'tabs_blocked_users',
    value: 'blockedUsers',
    breadcrumbValue: { icon: usersIcon, items: ['tabs_super_admin', 'tabs_blocked_users'] },
  },
];

export const CompanyUsersTableHeader = [
  {
    name: 'firstName',
    displayName: 'table_header_first_name',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'firstName',
  },
  {
    name: 'lastName',
    displayName: 'table_header_last_name',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'lastName',
  },
  {
    name: 'countryCode',
    displayName: 'table_header_country_code',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'countryCode',
  },
  {
    name: 'mobileNumber',
    displayName: 'table_header_mobile_number',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'mobileNumber',
  },
  {
    name: 'company',
    displayName: 'table_header_company',
    type: 'text',
    isRequired: true,
    isSelected: true,
    associatedKey: 'companyName',
  },
];

export const BlockedUsersTableHeader = [
  {
    name: 'firstName',
    displayName: 'table_header_first_name',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'firstName',
  },
  {
    name: 'lastName',
    displayName: 'table_header_last_name',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'lastName',
  },
  {
    name: 'countryCode',
    displayName: 'table_header_country_code',
    type: 'string',
    mandatory: true,
    isRequired: true,
    isSelected: true,
    associatedKey: 'countryCode',
  },
  {
    name: 'mobileNumber',
    displayName: 'table_header_mobile_number',
    type: 'string',
    mandatory: true,
    isRequired: true,
    isSelected: true,
    associatedKey: 'mobileNumber',
  },
  {
    name: 'status',
    displayName: 'table_header_status',
    type: 'text',
    isRequired: false,
    isSelected: true,
    translateVal: true,
    populateFunc: 'populateBlockedUserStatus',
  },
];
